import { Button, ButtonProps } from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Link, { LinkTo } from "@pathwright/ux/src/components/link/Link"
import Pathicon from "../../../pathicon/Pathicon"

export type SimpleButtonProps = {
  to?: LinkTo
  icon?: IconName
  leftIcon?: IconName
  rightIcon?: IconName
  label?: string
} & ButtonProps

const SimpleButton = ({
  to,
  icon,
  leftIcon,
  rightIcon,
  label,
  children,
  ...buttonProps
}: SimpleButtonProps) => {
  rightIcon = rightIcon || icon

  const buttonChildren = (
    <>
      {!!leftIcon && <Pathicon icon={leftIcon} />}
      <>{label || children}</>
      {!!rightIcon && <Pathicon icon={rightIcon} />}
    </>
  )

  return (
    <Button
      asChild={!!to}
      colorPalette="whiteAlpha"
      size="sm"
      textDecor="none"
      backdropFilter="auto"
      backdropBlur="8px"
      gap={1}
      css={{
        // Yikes: very specificly pulling in the edge of the button for the chevron left/right icons
        // for aesthetic appeal (visually, the spacing past the icon looks exsessive for this icon).
        "& .chakra-button__icon": {
          ml: leftIcon === "chevron-left" ? -1 : undefined,
          mr: rightIcon === "chevron-right" ? -1 : undefined
        }
      }}
      {...buttonProps}
    >
      {to ? <Link to={to}>{buttonChildren}</Link> : buttonChildren}
    </Button>
  )
}

export default SimpleButton
